<br>

<div class="w-full bg-gray-600 text-white flex justify-between items-center" style="padding: 5px 10px">
  <strong>Stamm - Arbeitszeiten</strong>
  <div><button class="btn" class="btn bg-white text-black" (click)="editDefaultWorkingTimes()">edit</button></div>
</div>

<table id="default_working_times" class="table" style="table-layout: fixed; width: 100%; border-collapse: collapse;">

  <tr>
    <!-- Wochentage anzeigen -->
    <td *ngFor="let day of defaultTimes; let i = index" class="daybox-top" [ngClass]="{'active-day': defaultTimes[i].active == '1'}">
      <strong>{{ getDayName(i) }}</strong>
    </td>
  </tr>

  <tr>
    <!-- Zeit-Eingabefelder für jeden Tag mit 'von, bis' und grünem Hintergrund bei Aktivierung -->
    <td *ngFor="let day of defaultTimes; let i = index" [ngClass]="{'active-day': defaultTimes[i].active == '1'}" class="daybox-bottom" style="width: 100%;">
      <span [ngClass]="{'strikethrough': defaultTimes[i].active == '0' || defaultTimes[i].active == null}">
      <span *ngIf="day.default_start && day.default_end"><strong>{{day.default_start}}</strong>Uhr - <strong>{{day.default_end}}</strong>Uhr</span>
      </span>
      <span *ngIf="!day.default_start && !day.default_end">keine Angabe</span>
    </td>
  </tr>
</table>



<div class="w-full bg-gray-600 text-white flex justify-between items-center" style="padding: 5px 10px">
  <strong>Abwesenheit</strong>
  
  <mat-paginator style="color: #fff; background-color: rgb(75, 85, 99);" [pageSizeOptions]="[10]" showFirstLastButtons aria-label="Select page of periodic elements"></mat-paginator>
  <div><button class="btn bg-white text-black" (click)="addAbsence()">+ Abwesenheit hinzufügen</button></div>
</div>

<table style="width: 100%" mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)">

  <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->

  <!-- Position Column -->
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by id"> ID</th>
    <td mat-cell *matCellDef="let element"> <strong>{{element.id}}</strong></td>
  </ng-container>

  <!-- Weight Column -->
  <ng-container matColumnDef="absence_type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by absence_type"> Grund </th>
    <td mat-cell *matCellDef="let element"><mat-icon ><span class="material-symbols-outlined">
      {{element.absence_type.icon}}</span></mat-icon> {{element.absence_type.name}} </td>
  </ng-container>

  <ng-container matColumnDef="created_at">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by created_at">am:</th>
    <td mat-cell *matCellDef="let element"> {{element.created_at  | date:"dd.MM.yyyy"}} </td>
  </ng-container>

  <ng-container matColumnDef="user">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by user">von:</th>
    <td mat-cell *matCellDef="let element"> {{element.user_id}} </td>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="start_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by start_date"> Start </th>
    <td mat-cell *matCellDef="let element"> {{element.start_date | date:"dd.MM.yyyy"}} ({{getWeekdayInGerman(element.start_date)}}) </td>
  </ng-container>

  <ng-container matColumnDef="end_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by end_date"> Ende </th>
    <td mat-cell *matCellDef="let element"> {{element.end_date | date:"dd.MM.yyyy"}} ({{getWeekdayInGerman(element.end_date)}}) </td>
  </ng-container>

  <ng-container matColumnDef="days">
    <th mat-header-cell *matHeaderCellDef> Tage </th>
    <td mat-cell *matCellDef="let element"> <strong>{{calculateDays(element.start_date, element.end_date)}} </strong></td>
  </ng-container>

  <ng-container matColumnDef="note">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by note"> Note </th>
    <td mat-cell *matCellDef="let element"> {{element.note}} </td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th class="text-left" mat-header-cell *matHeaderCellDef> Aktion </th>
    <td mat-cell *matCellDef="let element"> </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr class="cursor-pointer" (click)="gotoAbsenceDetails(row)" [class.selected]="row.id == selectedRowIndex" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<router-outlet (deactivate)="onRouterOutletActivate($event)"></router-outlet>



